module.exports = __webpack_public_path__ + "img/es-pc-step-3.17c0f1e9.jpg";